<!-- eslint-disable -->
<template>
  <div class="container">
    <div class="row psa-box">
      <div class="col-lg-12">
        <center>
          <h1>資金決済法に基づく表示</h1>
        </center>
        <div>
          <h2>（1）発行者の氏名、商号または名称</h2>
          <p>株式会社indent</p>
          <h2>（2）利用可能金額等</h2>
          <p>
            チャージFish（iOS）およびチャージFish（Android）のチャージ上限は以下のとおりです。
          </p>
          <p>上限1億fish</p>
          <h2>（3）使用期間または使用期限</h2>
          <p>チャージFish（iOS）およびチャージFish（Android）：有効期限なし</p>
          <p>
            ※無料配布Fishおよびウェブブラウザから購入したFish（チャージFish（Web))には最大180日の有効期限があります。有効期限は複数あり、発行条件等により異なります。詳しくはマイページをご確認ください。
          </p>
          <h2>（4）利用者からの苦情または相談を受ける窓口の所在地および連絡先</h2>
          <p>所在地：東京都千代田区神田三崎町3-6-12 神田三崎町ビル4階</p>
          <p>nola.cs@indent.co.jp</p>
          <h2>（5）使用することができる施設または場所の範囲</h2>
          <p>Nola iOSアプリおよびAndroidアプリ</p>
          <h2>（6）利用上の必要な注意</h2>
          <ul>
            <li>「<a href="/membership" target="_blank">Nola有料サービス利用規約</a>」をご覧ください。</li>
            <li>
              購入アイテムによって1fish当たりの購入単価は変動します。詳しくは購入画面でご確認ください。
            </li>
            <li>
              法令により認められる場合を除き、原則として、Fishの払い戻しはできません。
            </li>
            <li>
              Fishを他者に譲渡、転売、または現金に換金することはできません。
            </li>
            <li>
              チャージFish（iOS）、チャージFish（Android）は、購入したプラットフォーム上でのみ利用できます。詳細はマイページをご確認ください。
            </li>
          </ul>
          <h2>（7）未使用残高を知る方法</h2>
          <p>Nolaにログイン後、マイページでご確認いただけます。</p>
          <h2>（8）約款等</h2>
          <p><a href="/membership" target="_blank">Nola有料サービス利用規約</a>をご確認ください。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  // NOTE: metaタグの設定
  metaInfo() {
    if (process.env.NODE_ENV === "production") {
      return {};
    }
    return {
      meta: [
        {
          name: "robots",
          content: "none",
        },
      ],
    };
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.psa-box {
  background-color: var(--color-surface-subtle);
  padding: 100px 13% 50px 13%;
  border: solid 10px var(--color-border);
}
.psa-box h1 {
  font-size: var(--font-size-xxl);
  font-weight: var(--font-weight-bold);
  margin-top: 0px;
  margin-bottom: 30px;
  color: var(--color-text-normal);
  text-align: center;
  position: relative;
  display: inline-block;
  padding: 0 55px;
}
.psa-box h1:before,
.psa-box h1:after {
  content: "";
  position: absolute;
  top: 50%;
  display: inline-block;
  width: 45px;
  height: 1px;
  background-color: var(--color-text-normal);
}
.psa-box h1:before {
  left: 0;
}
.psa-box h1:after {
  right: 0;
}

.psa-box h2 {
  font-size: var(--font-size-xl);
  margin-top: 30px;
  margin-bottom: 20px;
  color: var(--color-text-normal);
  border-bottom: solid 1px var(--color-border);
}
.psa-box p {
  color: var(--color-text-normal);
}
.psa-box ul {
  padding-inline-start: 2rem;
  color: var(--color-text-normal);
}
.psa-box li {
  list-style-type: disc;
}
.psa-box a {
  color: var(--color-primary);
}

/*スマホ画面でサイドメニューを非表示*/
@media screen and (max-width: 576px) {
  /* 表示領域が576px以下の場合に適用するスタイル */
  .psa-box {
    padding: 50px 15px;
  }
  .psa-box h1 {
    font-size: var(--font-size-xl);
    margin-bottom: 20px;
  }
  .psa-box h2 {
    font-size: var(--font-size-md);
    margin-top: 30px;
    margin-bottom: 15px;
  }
  .psa-box p {
    font-size: var(--font-size-sm);
  }
}
</style>
